<template>
  <main ref="targetElement" class="notice page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('menuNotices') }}</h3>
    </section>

    <section>
      <div v-if="lists && lists.length > 0" class="list list-default notice-list">
        <div v-for="item in lists" :key="item.noticeSeq" class="list-box">
          <router-link :to="{ name: 'NoticeDetail' , params : { noticeId : item.noticeSeq, locale: $route.params.locale}}">
            <div class="list-cont">
              <p class="list-title">{{ item.noticeTitle }}</p>
              <div>
                <time class="list-date">{{ $moment(item.noticePublishDate).format('YY.MM.DD') }}</time>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div v-else class="list-nodata">{{ $t('list.nodata') }}</div>

      <loading v-if="loading" />

      <pagination
        v-if="pagination.total"
        :data="pagination"
        :more-activation="moreActivation"
        :is-mobile="isMobile"
        :minimum-size="listParams.pageSize"
        @movePage="movePage"
        @more="more"
      />
    </section>
  </main>
</template>
<script>
import list from '@/mixins/list'
import observeSize from '@/mixins/observeSize'
import noticeApi from '@/api/notice'

export default {
  components: {
    pagination: () => import('@/components/base/Pagination'),
    loading: () => import('@/components/base/Loading')
  },
  mixins: [list, observeSize],
  data () {
    return {
      loading: false
    }
  },
  watch: {
    '$route.query.page' (page, oldPage) {
      if (!page || this.isMobile) {
        return
      }
      const noticeOption = {
        pageNumber: page
      }
      this.getNotice(noticeOption)
    },
    isMobile (v) {
      if (!v) {
        this.lists = this.desserts
      } else {
        this.getNoticeMobile(this.$route.query.page)
      }
    },
    '$route.params.locale' () {
      if (this.$route.query.page !== '1') {
        this.pagination.current = 1
        this.$router.push({
          query: {
            page: 1
          }
        }).catch(e => {})
      }
      // this.listParams.pageNumber = 1
      if (this.isMobile) {
        this.getNoticeMobile(1)
      } else {
        this.getNotice({ pageNumber: 1 })
      }
    }
  },
  beforeMount () {
    // if (!this.$route.query.page) {
    //   this.$router.push({
    //     ...this.$route,
    //     query: {
    //       page: 1
    //     }
    //   })
    // }
    this.listParams.pageNumber = this.$route.query.page || 1
    this.listParams.pageSize = 20
    // this.listParams.pageSize = 2
  },
  mounted () {
    if (this.isMobile) {
      this.getNoticeMobile(this.listParams.pageNumber)
    } else {
      this.getNotice({ pageNumber: this.listParams.pageNumber })
    }
  },
  methods: {
    async getNoticeMobile (pageNumber) {
      this.loading = true
      const options = {
        pageNumber: 1,
        pageSize: Number(pageNumber) * this.listParams.pageSize
      }
      this.getListMobile(noticeApi.getNotice, options).then(() => {
        this.loading = false
      })
    },
    getNotice (options) {
      this.loading = true
      this.getList(noticeApi.getNotice, options).then(() => {
        this.lists = this.desserts
        this.loading = false
      })
    },
    more () {
      if (!this.moreActivation) {
        const index = this.pagination.current + 1
        this.$router.push({
          query: {
            page: index,
            size: 'mobile'
          }
        })

        const noticeOption = {
          pageNumber: index,
        }
        this.loading = true
        this.getList(noticeApi.getNotice, noticeOption).then(() => {
          this.lists = [
            ...this.lists,
            ...this.desserts,
          ]
          this.loading = false
        })
      }
    }
  }
}
</script>
